import documentClickedMixin from '@/mixins/component-document-clicked-mixin';
/**
 * @mixin
 */
export default {
	mixins: [documentClickedMixin],
	data() {
		return {
			selectedOption: null,
			expanded: false,
			popperMinWidth: 'auto'
		};
	},
	props: {
		labelText: {
			type: String,
			default: 'Click'
		},
		iconClassName: {
			type: String,
			default: ''
		},
		extendedIconClassName: {
			type: String,
			default: ''
		},
		iconBeforeLabel: {
			type: Boolean,
			default: null
		},
		iconAfterLabel: {
			type: Boolean,
			default: null
		},
		/**
		 * Array of objects in format
		 * {
		 * text: 'display text',
		 * value: 'value'
		 * }
		 */
		options: {
			type: Array,
			required: true
		}
	},
	created() {
		this.documentClickedHandler = this.handleDocumentClicked;
	},
	computed: {
		iconMenuClassName() {
			return this.expanded
				? this.extendedIconClassName || this.iconClassName
				: this.iconClassName;
		}
	},
	methods: {
		showOptions() {
			this.expanded = !this.expanded;
		},
		onSelectOption(option) {
			this.selectedOption = option;
			this.$emit('click', option);
			this.expanded = false;
		},
		handleDocumentClicked() {
			this.selectedOption = null;
			this.expanded = false;
		},
		setpopperMinWidth(value) {
			this.popperMinWidth = value;
		}
	}
};
